const state = () => {
  return {
    menu: [
      {
        icon: 'HomeIcon',
        pageName: 'side-menu-dashboard-overview-1',
        title: 'Dashboard',
        roles: ['admin', 'user']
      },
      {
        icon: 'EditIcon',
        pageName: 'side-menu-resident-upload-information',
        title: 'Agregar información',
        roles: ['admin', 'assistant', 'user']
      },
      {
        icon: 'FileTextIcon',
        pageName: 'files',
        title: 'Módulo Documentos',
        roles: ['admin']
      },
      {
        icon: 'ArchiveIcon',
        pageName: 'houses',
        title: 'Módulo de Casas',
        roles: ['admin']
      },
      {
        icon: 'UsersIcon',
        pageName: 'specialists',
        title: 'Módulo de Especialistas',
        roles: ['admin']
      },
      {
        icon: 'UsersIcon',
        pageName: 'residents',
        title: 'Módulo de Residentes',
        roles: ['admin']
      },
      {
        icon: 'DatabaseIcon',
        pageName: 'kardex',
        title: 'Módulo de Kardex',
        roles: ['admin']
      },
      {
        icon: 'FileTextIcon',
        pageName: 'medicines',
        title: 'Módulo de Medicinas',
        roles: ['admin']
      },
      {
        icon: 'UsersIcon',
        pageName: 'clients',
        title: 'Módulo de Clientes',
        roles: ['admin']
      }
    ]
  }
}

// getters
const getters = {
  menu: state => state.menu
}

export default {
  namespaced: true,
  state,
  getters
}
